<template>
  <div class="wiki-detail-comment">
    <div v-if="needLogin" ref="sendComment" class="detail-comment">
      <send-article-box
        ref="sendBox"
        :on-ok="onComment"
        :placeholder="loginUid > 0 ? '友善发言，文明交流' : $t('login_to_post')"
        :send-btn-text="$t('comment')"
        :show-video="false"
      />
    </div>
    <div v-if="needLogin" class="wiki-comment-list">
      <!--      :loadStatus="loadCommentStatus"-->
      <scroll-comp ref="scrollComp" :restore-position="false" :page-load="getCommentList">
        <p class="comment-num">
          {{ $t("comments") }}<span>（{{ detail.comment_count }}）</span>
        </p>

        <comment-list-item
          v-for="(item, index) in list"
          :key="item.id"
          :floor="'#' + (pagination.total - index)"
          :is-lz="item.user.uid == user.uid"
          :item="item"
          :pid="item.id"
          @onDel="onDelComment"
          @onTop="onTopComment"
        />
      </scroll-comp>
    </div>
    <!-- 查看评论 -->
    <comment-dialog />
    <!-- 二级弹窗 -->
    <secondary-dialog />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import ScrollComp from "@/components/Scroll";
import SendArticleBox from "../../components/sendArticleBox";
import CommentListItem from "../../components/commentListItem";
import SecondaryDialog from "../../components/secondaryDialog";
import CommentDialog from "../../components/commentDialog";
// api
import { apiCommentAdd } from "@/api/commentApi";

export default {
  name: "DetailComment",
  components: {
    ScrollComp,
    SendArticleBox,
    CommentListItem,
    SecondaryDialog,
    CommentDialog
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loadCommentStatus: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(["loginUid"])
  },
  watch: {
    loadCommentStatus(val, oVal) {
      this.$refs.scrollComp.loadStatus = val;
    }
  },
  methods: {
    // 添加评论
    onComment(data) {
      if (!this.isLogin("登录后才能评论")) {
        return false;
      }
      let content = data.html;
      if (data.imgs.length) {
        let imgs = '<div class="comment-img-wrapper">';
        data.imgs.forEach(item => {
          imgs += `<div class="img-item"><img src="${item.url}" alt=""></div>`;
        });
        imgs += "</div>";
        content += imgs;
      }
      let params = {
        content: content,
        content_id: this.detail.id,
        pid: 0
      };
      if (!data.text) {
        this.$message({
          type: "info",
          message: "请填写评论内容"
        });
        return;
      }
      console.log(params);
      this.$emit("setLoading", true);
      apiCommentAdd(params)
        .then(({ data }) => {
          this.detail.comment_count++;
          this.$emit("refresh", this.detail);
          this.getCommentList("refresh");
          this.$refs.sendBox.onClear();
        })
        .finally(_ => {
          this.$emit("setLoading", false);
        });
    },
    // 获取评论列表
    getCommentList(type) {
      console.log("~~~~~~");
      this.$emit("getCommentList", type);
    },
    // 删除评论
    onDelComment(item) {
      let index = this.list.indexOf(item);
      this.list.splice(index, 1);
      this.detail.comment_count--;
      this.$emit("refresh", this.detail);
    },
    // 置顶评论
    onTopComment(item) {
      this.$emit("getCommentList", "refresh");
    },
    // 滚动到评论处
    async onScrollToCommentBox() {
      if (!this.isLogin()) {
        return false;
      }

      let $ele = this.$refs.sendComment;
      $ele.querySelector(".article-edit-box").focus();
      await this.$nextTick();
      window.scrollTo({
        top: $ele.offsetTop,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.detail-comment {
  background-color: #fff;
  border-radius: 2px;
  margin-top: 4px;
  padding: 10px 0;
}
.wiki-detail-body {
  padding: 10px 14px;
}

.wiki-comment-list {
  background: #fff;
  margin-top: 10px;
  border-radius: 2px;
  margin-top: 28px;
  min-height: 500px;
  margin-top: 4px;
  padding: 10px 0;

  .comment-num {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    span {
      color: #333;
      font-size: #666;
      font-weight: 400;
    }
  }
}
/deep/ .comment-img-wrapper {
  display: flex;
  margin-bottom: 20px;

  .img-item {
    width: 110px;
    height: 100px;
    cursor: pointer;
    position: relative;
    border-radius: 6px;
    overflow: hidden;

    & + .img-item {
      margin-left: 12px;
    }

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: fade(#000, 70%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
